'use strict';
angular.module('editingCenterAppTopicModule', []).controller('editingCenterAppTopicController', [
    '$scope',
    'beforeonload',
    '$element',
    '$state',
    '$window',
    '$compile',
    '$validation',
    '$q',
    '$filter',
    '$timeout',
    'trsHttpService',
    'editingCenterAppService',
    'editcenterRightsService',
    'initAddMetaDataService',
    'initAppRequiredBtnService',
    'appDictionaryBtnService',
    'filterEditctrBtnsService',
    'initeditctrBtnsService',
    'editIsLock',
    'editingCenterService',
    'ueditorService',
    'trsSelectDocumentService',
    'sensitiveWordCheckService',
    'modalDialog',
    'jsonArrayToStringService',
    'storageListenerService',
    'editFusionEditorService',
    'newMediaService',
    'messagePublishService',
    function(
        $scope,
        beforeonload,
        $element,
        $state,
        $window,
        $compile,
        $validation,
        $q,
        $filter,
        $timeout,
        trsHttpService,
        editingCenterAppService,
        editcenterRightsService,
        initAddMetaDataService,
        initAppRequiredBtnService,
        appDictionaryBtnService,
        filterEditctrBtnsService,
        initeditctrBtnsService,
        editIsLock,
        editingCenterService,
        ueditorService,
        trsSelectDocumentService,
        sensitiveWordCheckService,
        modalDialog,
        jsonArrayToStringService,
        storageListenerService,
        editFusionEditorService,
        newMediaService,
        messagePublishService
    ) {
        initStatus();
        initData();
        editingCenterAppService.addFuture($scope, ['sendmessage']);

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.status = {
                newsFormError: [],
                switch: 'manuscriptInfo', // 默认选中稿件信息
                support: {
                    content: '', // 提交给辅助写作的纯文本
                },
                isCheckSensitiveWords: false,
                zhengwen: false,
                openBtn: true,
                // bitFaceTit: "查看痕迹",
                bigFaceSwitch: { status: false },
                sensitiveWordTit: '敏感词校验',
                isSecondReview: false,
                isSignedOrRevoked: false,
                position: $state.params.appplatform,
                isEditDraft: !!$state.params.appmetadataid,
                heimaCheckTit: '错别字校对',
                // belongChannelTimeout: false, //等待关联栏目数据加载完成
                showVideoAudioDiv: false, // 初始化音视频所需的div
                isFusionEditor: $state.current.name == 'fusiontopic', // 是否来自融合编辑器
                checkExists: {
                    // 主持人嘉宾校验
                    fn(name) {
                        let deffer = $q.defer();
                        let params = {
                            serviceid: 'mlf_appexchange',
                            methodname: 'checkExists',
                            SiteId: $state.params.appsiteid,
                            Name: name,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                            deffer.resolve(resp);
                        });
                        return deffer.promise;
                    },
                },
                isawaitrevise: $state.params.isawaitrevise,
                hasTitleSynced: false, // 标题是否已经同步给列表标题
            };
            $scope.data = {
                userName: '',
                relSubjectSelectedItems: [],
                relSubjectGroup: [], // 相关专题分组
                relSubjectSelectedGroup: [], // 相关专题所选分组
                selectNewArray: [], // 相关新闻选中数据
                selectSubjectArray: [], // 相关专题选中数据
                commentSet: editingCenterAppService.initCommentSet(), // 初始化评论设置
                docGenre: editingCenterAppService.initDocGenre(), // 初始化稿件题材
                copyVersion: [],
                version: [],
                KEYWORDS: [],
                path: {
                    '-1': 'editingCenterIwoPersonalVersionTime',
                    '1': 'editingCenterAppPersonalVersionTime',
                    '2': 'editingCenterWebsitePersonalVersionTime',
                    '3': 'editingCenterPaperPersonalVersionTime',
                    '4': 'editingCenterWeixinPersonalVersionTime',
                },
                originList: [
                    {
                        name: '内部原创',
                        value: '2',
                    },
                    {
                        name: '整合原创',
                        value: '1',
                    },
                    {
                        name: '特约稿',
                        value: '3',
                    },
                    {
                        name: '通讯员稿',
                        value: '4',
                    },
                    {
                        name: '报道组稿',
                        value: '5',
                    },
                    {
                        name: '其他',
                        value: '6',
                    },
                ],
                listStyle: [
                    {
                        desc: '图文',
                        value: '0',
                    },
                    {
                        desc: '大图',
                        value: '3',
                    },
                ], // 列表样式
            };
            if ($scope.status.isFusionEditor) {
                $scope.params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'getAPPFusionDoc',
                    sourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                };
            } else {
                $scope.params = {
                    serviceid: 'mlf_appmetadata',
                    methodname: 'getTopicDoc',
                    ChnlDocId: $state.params.appchnldocid,
                };
            }
            $scope.status.hasVersionTime = !!angular.isDefined($state.params.appchnldocid);
            emitCloseWindow();
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function() {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.topicForm.$error) {
                errorArray.push(error);
            }
            $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
            if ($scope.status.newsFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.newsFormError = errorArray;
            }
            return $scope.status.newsFormError; // 返回
        };

        /**
         * [toggleEditor description] 切换编辑器显隐
         * @return {[type]} [description]
         */
        $scope.toggleEditor = function() {
            $scope.status.zhengwen = !$scope.status.zhengwen;
            if ($scope.status.zhengwen) {
                // 隐藏编辑器
                $('.body_manuscript_content').addClass('editorHidden');
            } else {
                $('.body_manuscript_content').removeClass('editorHidden');
            }
        };

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            // window.onbeforeunload = function() {
            //     if ($scope.list.ISSECONDREVIEW != '1' || $scope.status.isSignedOrRevoked === false) {
            //         localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $state.params.appmetadataid }));
            //     }
            // };
            editingCenterService.allAppCloseWindow($scope, {typeName: 'app', saveLocal: false, hascondition: true});
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            $scope.status.showVideoAudioDiv = false;
            getCutPictureWidthHeight();
            (angular.isDefined($state.params.appchnldocid) ? initEditData() : initNewData()).then(function() {
                if (!$scope.data.imgSize && $scope.list) {
                    changeMode($scope.list.LISTSTYLE || '0');
                }
                beforeonload.beforeonloadAlert($scope);
            });
            if (!$scope.status.isFusionEditor) {
                // 获取"查看痕迹"权限
                /* editcenterRightsService.getRightsofBigFace($state.params.appsiteid, 'appsite.trace').then(function(data) {
                    $scope.status.bigFaceRights = !!data["appsite.trace.chakan"] ? "true" : "false";
                });*/
                initBtnArray();
            }
        }

        /**
         * [getCutPictureWidthHeight description]获取图片编辑默认宽高
         * @return {[type]} [description]
         */
        function getCutPictureWidthHeight() {
            var params = {
                serviceid: 'mlf_appconfig',
                methodname: 'getPicsSize',
                objectid: $state.params.appsiteid,
            };
            var pictureSizeArr = [
                'ACTIVITYSIZE',
                'LIVESIZE',
                'NEWSPICSIZE',
                'PICFOCUS',
                'PICSIZE',
                'SPECIALSIZE',
                'TOPICSIZE',
                'VIDEOSIZE',
                'WEBPAGESIZE',
                'FOCUSIMAGESIZE',
                'FIGURESIZE',
                'ACTIVITYBIGSIZE',
                'LIVEBIGSIZE',
                'NEWSBIGPICSIZE',
                'PICBIGFOCUS',
                'PICBIGSIZE',
                'VIDEOSBIGIZE',
                'WEBPAGEBIGSIZE',
                'TOPBIGSIZE',
            ];
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.pictureSize = {};
                pictureSizeArr.forEach(function(value, item) {
                    $scope.status.pictureSize[value] = data[value] = !data[value] ? '100,100' : data[value];
                });
                if (!$scope.data.imgSize && $scope.list) {
                    changeMode($scope.list.LISTSTYLE || '0');
                }
            });
        }

        /**
         * [initNewData description] 初始化新页面
         * @return {[type]} [description]
         */
        function initNewData() {
            var deffer = $q.defer();
            $scope.list = initAddMetaDataService.initTopic();
            $scope.list.LISTSTYLE = 0;
            loadDirective().then(function() {
                $scope.status.showVideoAudioDiv = true;
                deffer.resolve();
            });
            return deffer.promise;
            // getBelongChannel();
        }

        /**
         * [loadDirective description] 加载相关组件
         * @return {[type]} [description]
         */
        function loadDirective() {
            var defer = $q.defer();
            getBtnRights()
                .then(function() {
                    return getSiteConfig();
                })
                .then(function(data) {
                    $scope.status.newFeatures = data.APPMODULEID === undefined ? '' : data.APPMODULEID; // app编辑器新功能；分别为 插入导语 插入组件 插入官员/话题 预览
                    $scope.status.setFont = {
                        // app编辑器设置字体大小 类型 行距 功能
                        fontFamilyCustom: data.TYPEFACEDEFINITION == '1',
                        fontSize: angular.isDefined(data.EDITORWORDS) ? data.EDITORWORDS.value : '12px',
                        lineSpacing: angular.isDefined(data.ROWSPACINGSETTING) ? data.ROWSPACINGSETTING.value : '1.75',
                    };
                    LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function() {
                        $scope.status.siteId = $state.params.appsiteid;
                        var ueditor =
                            '<ueditor-for-app site-id="{{status.siteId}}" save="previewSave()" form="topicForm" type="{{\'app\'}}" picture-size="data.imgSize" new-features="status.newFeatures" set-font="status.setFont" versionid = "data.lastVersionid" list="list" infullscreen="status.infullscreen" authority="status.btnRights" has-content="status.hasContent"></ueditor-for-app>';
                        ueditor = $compile(ueditor)($scope);
                        $element.find('ueditorLocation').append(ueditor);
                        $scope.status.support.content = $scope.list.CONTENT;
                        var supportCreation =
                            '<support-creation is-trs-check-menu="{{\'true\'}}" parent-status="status" big-face-switch="status.bigFaceSwitch" has-editor="true" media-type="{{\'1\'}}" toggle-sidebar="true" is-check-sensitive-words="status.isCheckSensitiveWords" list="list"></support-creation>';
                        supportCreation = $compile(supportCreation)($scope);
                        $element.find('supportcreation').append(supportCreation);
                        $timeout(function() {
                            defer.resolve();
                        }, 1500);
                    });
                });
            var draftList =
                '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="topicForm"></editor-dir>' +
                '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $element.find('editor').append(draftList);
            return defer.promise;
        }

        /**
         * [getBtnRights description] 获取原子权限
         * @return {[type]} [description]
         */
        function getBtnRights() {
            var defer = $q.defer();
            if ($scope.status.isawaitrevise) {
                editcenterRightsService.initIwoListBtn('iwo.xiuding').then(function(rights) {
                    $scope.status.btnRights = rights;
                    defer.resolve();
                });
            } else if (!$scope.status.isFusionEditor) {
                var rightType = ['app.daibian', 'app.daishen', 'app.yiqianfa'];
                editcenterRightsService.initAppListBtn(rightType[$state.params.appplatform], $state.params.appchannelid).then(function(rights) {
                    $scope.status.btnRights = rights;
                    defer.resolve();
                });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        /**
         * [getSiteConfig description]获取站点的配置信息
         * @return {[type]}           [description]
         */
        function getSiteConfig() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_appmetadata',
                methodname: 'findAppSiteById',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.manuAttr = {
                    relatedTopic: data.RELATEDTOPIC,
                    connectionColumn: data.CONNECTIONCOLUMN,
                    relatedOfficial: data.RELATEDOFFICIAL,
                };
                initRelatedColumnData();
                initRelatedOfficials();
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [initRelatedOfficials description] 初始化相关官员
         * @return {[type]} [description]
         */
        function initRelatedOfficials() {
            if ($scope.status.manuAttr.relatedOfficial != 1) {return;}
            $scope.status.relatedOfficial =
                !!(angular.isArray($scope.list.RELEVANTOFFICIALSIDS) && $scope.list.RELEVANTOFFICIALSIDS.length > 0);
            let params = {
                serviceid: 'mlf_appexchange',
                methodname: 'getZJXWOfficers',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                $scope.data.relatedOfficialList =
                    angular.isObject(resp) && angular.isObject(resp.DATA) && angular.isArray(resp.DATA.officer_list) ? resp.DATA.officer_list : [];
                if (!angular.isArray($scope.list.RELEVANTOFFICIALSIDS)) {return;}
                $scope.data.selectedOfficial = $scope.data.relatedOfficialList.filter((item) => $scope.list.RELEVANTOFFICIALSIDS.some((_item) => _item == item.id));
            });
        }

        /**
         * [closeRelatedOfficial description] 关闭相关官员选项
         * @return {[type]} [description]
         */
        $scope.closeRelatedOfficial = function() {
            if (!$scope.status.relatedOfficial) {
                $scope.status.relatedOfficial = true;
                if (!angular.isArray($scope.data.selectedOfficial)) {return;}
                $scope.list.RELEVANTOFFICIALSIDS = $scope.data.selectedOfficial.map((item) => item.id + '');
            } else {
                $scope.status.relatedOfficial = false;
                $scope.list.RELEVANTOFFICIALSIDS = [];
            }
        };

        /**
         * [selectedOfficials description] 选中了相关官员
         * @return {[type]} [description]
         */
        $scope.selectedOfficials = function() {
            $scope.list.RELEVANTOFFICIALSIDS = $scope.data.selectedOfficial.map((item) => item.id + '');
        };

        /**
         * [initRelatedColumnData description] 初始化相关栏目数据，以适应级联菜单
         * @return {[type]} [description]
         */
        function initRelatedColumnData() {
            if ($scope.status.manuAttr.connectionColumn == 1) {
                $scope.status.relatedColumn = [
                    [
                        {
                            name: $scope.list.BELONGCHANNEL.TYPE,
                            id: $scope.list.BELONGCHANNEL.ID,
                        },
                        {
                            name: $scope.list.BELONGCHANNEL.NAME,
                            id: $scope.list.BELONGCHANNEL.VALUE,
                        },
                    ],
                ];
            }
        }

        /**
         * [getZJXWColumns description] 获取相关栏目列表
         * @return {[type]} [description]
         */
        $scope.getZJXWColumns = function() {
            let deffer = $q.defer();
            let params = {
                serviceid: 'mlf_appexchange',
                methodname: 'getZJXWColumns',
                SiteId: $state.params.appsiteid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((resp) => {
                let treeData = (() => {
                    if (
                        !angular.isObject(resp) ||
                        !angular.isObject(resp.DATA) ||
                        !angular.isArray(resp.DATA.all_columns) ||
                        resp.DATA.all_columns.length == 0
                    ) {return [];}
                    return resp.DATA.all_columns.map((item, index) => ({
                        id: item.id,
                        name: item.type,
                        CHILDREN: item.column_list.map((item_, index_) => {
                            item_.hasChildren = 0;
                            return item_;
                        }),
                    }));
                })();
                deffer.resolve(treeData);
            });
            return deffer.promise;
        };

        /**
         * [selectRelatedColumn description] 选中相关栏目
         * @return {[type]} [description]
         */
        $scope.selectRelatedColumn = function() {
            $scope.list.BELONGCHANNEL =
                angular.isArray($scope.status.relatedColumn) &&
                angular.isArray($scope.status.relatedColumn[0]) &&
                $scope.status.relatedColumn[0][1].id
                    ? {
                        ID: $scope.status.relatedColumn[0][0].id,
                        TYPE: $scope.status.relatedColumn[0][0].name,
                        NAME: $scope.status.relatedColumn[0][1].name,
                        VALUE: $scope.status.relatedColumn[0][1].id,
                    }
                    : {};
        };

        /**
         * [initEditData description] 初始化编辑页
         * @return {[type]} [description]
         */
        function initEditData() {
            var defer = $q.defer();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                $scope.list = data;
                document.title = data.TITLE;
                $scope.data.relNewsSelectedItems = angular.isDefined(data.RELATEDNEWS) ? data.RELATEDNEWS : [];
                $scope.status.isSecondReview = !!(angular.isDefined(data.ISSECONDREVIEW) && data.ISSECONDREVIEW == '1');
                initKeyWords();
                initRelavantSpecialDoc();
                reWriteImg();
                initOrigin();
                syncTitleToListTitle();
                // getBelongChannel();
                getVersion()
                    .then(function() {
                        return loadDirective();
                    })
                    .then(function() {
                        $scope.status.showVideoAudioDiv = true;
                        defer.resolve();
                    });
                getPropagandaReview();
            });
            // 稿件加锁
            editIsLock.lockDraft($state.params.appmetadataid);
            return defer.promise;
        }

        /**
         * [initRelavantSpecialDoc description] 初始化相关专题
         * @return {[type]} [description]
         */
        function initRelavantSpecialDoc() {
            if (angular.isDefined($scope.list.RELEVANTSPECIALDOC) && $scope.list.RELEVANTSPECIALDOC.length != 0) {
                angular.forEach($scope.list.RELEVANTSPECIALDOC, function(data, index) {
                    $scope.data.relSubjectSelectedItems.push({
                        METADATAID: data.METADATAID,
                        LISTTITLE: data.LISTTITLE,
                        SPECIALGROUPID: data.SPECIALGROUPID,
                    });
                    $scope.data.relSubjectSelectedGroup.push({
                        name: data.SPECIALGROUPNAME,
                        value: data.SPECIALGROUPID,
                    });
                });
                var i = 0;
                initRelSubjectGroup($scope.list.RELEVANTSPECIALDOC[i]);
            }

            /**
             * [initRelSubjectGroup description] 初始化相关专题稿件的分组
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            function initRelSubjectGroup(item) {
                var params = {
                    methodname: 'querySpecialGroupsFromData',
                    serviceid: 'mlf_specialgroup',
                    MetaDataId: item.METADATAID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.relSubjectGroup[i] = data.DATA;
                    angular.forEach($scope.data.relSubjectGroup[i], function(value, key) {
                        value.name = value.SPECIALGROUPNAME;
                        value.value = value.SPECIALGROUPID;
                    });
                    i++;
                    if (i < $scope.list.RELEVANTSPECIALDOC.length) {
                        initRelSubjectGroup($scope.list.RELEVANTSPECIALDOC[i]);
                    }
                });
            }
        }

        /**
         * [initKeyWords description]初始化关键词
         * @return {[type]} [description]
         */
        function initKeyWords() {
            if ($scope.list.KEYWORDS !== '') {
                var KEYWORDS = $scope.list.KEYWORDS.split(';');
                $scope.data.KEYWORDS = [];
                angular.forEach(KEYWORDS, function(data, index, array) {
                    $scope.data.KEYWORDS.push({
                        name: data,
                    });
                });
            } else {
                $scope.data.KEYWORDS = [];
            }
        }

        /**
         * [getVersion description]获取流程版本与操作日志
         * @return {[type]} [description]
         */
        function getVersion(id) {
            var deffer = $q.defer();
            var metadataid = angular.isDefined(id) ? id : $state.params.appmetadataid;
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(
                function(data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    $scope.status.hasVersionTime = true;
                    $scope.data.lastVersionid = data.lastVersionid;
                    deffer.resolve();
                },
                function() {
                    deffer.resolve();
                }
            );
            return deffer.promise;
        }

        /**
         * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
         * @param  {[type]}  key [description] 操作日志或流程版本的数据
         * @return {Boolean}     [description]
         */
        $scope.isShowVersion = function(key) {
            if (key === undefined) {
                return false;
            } else {
                for (var i in key) {
                    return true;
                }
                return false;
            }
        };

        /**
         * 获取宣传部评审流程
         */
        function getPropagandaReview() {
            var deffer = $q.defer();
            editingCenterService.getPropagandaReview(1, $state.params.appmetadataid).then(function(data) {
                $scope.data.propagandaReview = data;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [reWriteImg description]回写图片列表数据
         * @return {[type]} [description]
         */
        function reWriteImg() {
            var imgArray = ['LISTPICS', 'FOCUSIMAGE', 'FIGURE'];
            angular.forEach(imgArray, function(data, index) {
                if ($scope.list[data] !== 0) {
                    var arrayDocPic = [];
                    angular.forEach($scope.list[data], function(dataC, indexC) {
                        arrayDocPic.push({
                            APPFILE: dataC.APPFILE,
                            APPDESC: dataC.APPDESC,
                            PERPICURL: dataC.PERPICURL,
                        });
                    });
                    $scope.list[data] = arrayDocPic;
                }
            });
        }

        /**
         * [initBtnArray description] 初始化按钮
         * @return {[type]} [description]
         */
        function initBtnArray() {
            if ($scope.status.isawaitrevise) {
                // 待修订状态的编辑页只有保存按钮和修订按钮，在此处加入保存按钮
                addBtn();
                return;
            }
            // 所需的按钮
            $scope.data.appRequiredBtns = initAppRequiredBtnService.initAppRequiredBtns()[$state.params.appplatform];
            // 根据不同平台调用不同权限方法
            $scope.data.rightsMethod = ['app.daibian', 'app.daishen', 'app.yiqianfa'];
            initeditctrBtnsService.initAppData($state.params.appchannelid, $scope.data.rightsMethod[$state.params.appplatform]).then(function(data) {
                // 字典按钮
                $scope.data.dictionaryBtn = [
                    appDictionaryBtnService.initAppCompBtn(),
                    appDictionaryBtnService.initAppPendBtn(),
                    appDictionaryBtnService.initAppSignBtn(),
                ];
                initeditctrBtnsService.initBtns(data, $scope.data.dictionaryBtn[$state.params.appplatform]).then((btns) => {
                    $scope.status.btnStatus = btns;
                    // 最终得到的按钮
                    $scope.data.arrayBtn = filterEditctrBtnsService.filterBtn($scope.status.btnStatus, $scope.data.appRequiredBtns);
                    checkSiteCanSaveAndPub().then(function() {
                        addBtn();
                    });
                });
            });
        }

        /**
         * [checkSiteCanSaveAndPub description] 校验站点是否设置了不显示“保存并发布”按钮
         * @return {[type]} [description]
         */
        function checkSiteCanSaveAndPub() {
            var defer = $q.defer();
            if ($state.params.appplatform == 2) {
                var params = {
                    serviceid: 'mlf_appconfig',
                    methodname: 'canSaveAndPub',
                    SiteId: $state.params.appsiteid,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    var isNotShow = data.substring(1, data.indexOf('"', 1));
                    if (isNotShow == 'true') {
                        var hasPubSave = false;
                        var hasPubSaveIndex;
                        angular.forEach($scope.data.arrayBtn, function(value, key) {
                            // 判断是否含有保存并发布按钮
                            if (value.RIGHTINDEX == 419) {
                                hasPubSave = true;
                                hasPubSaveIndex = key;
                            }
                        });
                        if (hasPubSave === true) {
                            // 在已签发平台删除保存并发布按钮
                            $scope.data.arrayBtn.splice(hasPubSaveIndex, 1);
                        }
                    }
                    defer.resolve();
                });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        /**
         * [addBtn description] 增加'保存''关闭'等按钮
         */
        function addBtn() {
            $scope.data.arrayBtn = $scope.data.arrayBtn ? $scope.data.arrayBtn : [];
            var OPERDESC = ['保存', '保存'];
            var OPERFUN = ['save', 'save'];
            if ($state.params.appplatform < 2) {
                $scope.data.arrayBtn.unshift({
                    RIGHTINDEX: 'save',
                    OPERDESC: OPERDESC[$state.params.appplatform],
                    OPERNAME: '',
                    OPERFUN: OPERFUN[$state.params.appplatform],
                });
            }
            // $scope.data.arrayBtn.push({
            //     RIGHTINDEX: "close",
            //     OPERDESC: "关闭",
            //     OPERNAME: "",
            //     OPERFUN: "close"
            // });
        }

        /**
         * [handleBtnClick description] 绑定按钮点击事件
         * @param  {[type]} funname [description]
         * @return {[type]}         [description]
         */
        $scope.handleBtnClick = function(funname) {
            eval('$scope.' + funname + '()');
        };

        /**
         * [updateCKSelection description] 复选框的回调函数
         * @param  {[type]} attribute [description]
         * @return {[type]}           [description]
         */
        $scope.updateCKSelection = function(attribute) {
            // if (attribute === 'ISFOCUSIMAGE' && $state.params.appplatform === '2') {
            //     modalDialog.alertType('', '稿件已签发后，无法勾选或取消勾选栏目焦点图', 'error', false, function() {});
            //     return;
            // }
            $scope.list[attribute] = $scope.list[attribute] == '0' ? '1' : '0';
        };

        /**
         * [deleteUploaderImg description]删除上传后的图片
         * @param  {[str]} attribute [description]要删除的属性
         * @param  {[num]} index     [description]下标
         * @return {[type]}           [description]
         */
        $scope.deleteUploaderImg = function(attribute, index) {
            if (attribute === 'LISTPICS') {
                $scope.list[attribute][index] = {
                    APPFILE: '',
                    APPDESC: '',
                    PERPICURL: '',
                };
            } else {
                $scope.list[attribute] = [];
            }
        };

        /**
         * [invalidTag description] 检验关键词的总个数和总记录长度
         * @param  {[type]} tag [description]
         * @return {[type]}     [description]
         */
        $scope.invalidTag = function(tag) {
            var reg = /^[^<>\/;]*$/;
            if (tag.name.length > 20) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '单个关键词长度不能超过20！';
            }
            if (!reg.test(tag.name)) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '不能包含特殊字符！';
            }
        };
        $scope.checkTag = function(tag) {
            var len = $scope.data.KEYWORDS.length;
            if (len == 10) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '关键词个数不能超过10个！';
                return false;
            } else {
                $scope.keywordsTips = '';
                $scope.isShowKeywordTips = false;
            }
            if (tag.name.indexOf(' ') > -1) {
                var spaceArr = tag.name.split(' ');
                $timeout(function() {
                    $scope.data.KEYWORDS.pop();
                    var containArr = [];
                    for (var j = 0; j < $scope.data.KEYWORDS.length; j++) {
                        containArr.push($scope.data.KEYWORDS[j].name);
                    }
                    for (var i = 0; i < spaceArr.length; i++) {
                        if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                            $scope.data.KEYWORDS.push({ name: spaceArr[i] });
                            containArr.push(spaceArr[i]);
                        }
                    }
                });
            }
        };
        $scope.leave = function() {
            // $scope.isShowKeywordTips = false;
        };
        $scope.enter = function() {
            var reg = /^[^<>\/]*$/;
            if (angular.isDefined($scope.KEYWORDTEXT) && (!reg.test($scope.KEYWORDTEXT) || $scope.KEYWORDTEXT.length > 20)) {
                $scope.isShowKeywordTips = true;
            }

            /* if (angular.isDefined($scope.keywordsTips) && $scope.keywordsTips !== "") {
                $scope.isShowKeywordTips = true;
            }*/
        };

        /**
         * [getKeywordsOrAbstract description]提取关键词或摘要
         * @param  {[str]} type [description]关键词类型或摘要
         * @return {[type]}      [description]
         */
        $scope.getKeywordsOrAbstract = function(type) {
            editingCenterService.getKeywordsOrAbstract(type, ueditorService.bindContent()).then(
                function(data) {
                    if (type === 'keywords') {
                        if (data !== '""') {
                            var arr = [];
                            var keywordsArray = data.substring(1, data.length - 1).split(';');
                            angular.forEach(keywordsArray, function(value, key) {
                                arr.push({
                                    name: value,
                                });
                            });
                            $scope.data.KEYWORDS = angular.isArray($scope.data.KEYWORDS) ? $scope.data.KEYWORDS : [];
                            $scope.data.KEYWORDS = $scope.data.KEYWORDS.concat(arr);
                            $scope.data.KEYWORDS = $filter('unique')($scope.data.KEYWORDS, 'name');
                            if ($scope.data.KEYWORDS.length > 10) {
                                $scope.data.KEYWORDS = $scope.data.KEYWORDS.splice(0, 10);
                            }
                        } else {
                            return;
                        }
                    }
                    if (type === 'abstract') {$scope.list.ABSTRACT = data.substring(1, data.length - 1);}
                },
                function(data) {}
            );
        };

        /**
         * [clearAllKeywords description]清除所有关键词
         * @return {[type]} [description]
         */
        $scope.clearAllKeywords = function() {
            $scope.data.KEYWORDS = [];
        };

        /**
         * [visualChooseWindow description] 可视化选择弹窗
         * @param  {[type]} type [description]
         * @return {[type]}      [description]
         */
        $scope.visualChooseWindow = function(type) {
            trsSelectDocumentService.trsSelectDocument(
                {
                    siteid: $state.params.appsiteid,
                    relNewsData: type == 'relSubjectSelectedItems' ? [] : angular.copy($scope.data[type]),
                    position: $state.params.appplatform,
                    showMetadaId: true,
                    isApp: true,
                    docType: '6',
                    searchSpecialDoc: type == 'relSubjectSelectedItems',
                    platform: 7,
                },
                function(result) {
                    if (type == 'relNewsSelectedItems') {
                        angular.forEach(result, function(value, key) {
                            value.METADATAID = value.metadataId;
                            value.LISTTITLE = value.title;
                        });
                        $scope.data[type] = result;
                    } else {
                        var i = 0;
                        var index = $scope.data[type].length;
                        var hasGroupArray = [];
                        queryRelSubjectGroup(result[i], function() {
                            $scope.data[type] = $scope.data[type].concat(hasGroupArray);
                        });
                    }

                    /**
                     * [queryRelSubjectGroup description] 请求相关专题稿件的分组
                     * @param  {[type]}   item     [description] 当前稿件
                     * @param  {Function} callback [description] 回调函数
                     * @return {[type]}            [description]
                     */
                    function queryRelSubjectGroup(item, callback) {
                        item.METADATAID = item.metadataId;
                        item.LISTTITLE = item.title;
                        var params = {
                            methodname: 'querySpecialGroupsFromData',
                            serviceid: 'mlf_specialgroup',
                            MetaDataId: item.METADATAID,
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                            if (data.DATA.length === 0) {
                                modalDialog.alertType('相关专题"' + item.LISTTITLE + '"没有分组', '', 'error', 'confirm');
                                i++;
                            } else {
                                $scope.data.relSubjectGroup[index] = data.DATA;
                                angular.forEach($scope.data.relSubjectGroup[index], function(value, key) {
                                    value.name = value.SPECIALGROUPNAME;
                                    value.value = value.SPECIALGROUPID;
                                });
                                $scope.data.relSubjectSelectedGroup[index] = $scope.data.relSubjectGroup[index][0];
                                item.SPECIALGROUPID = $scope.data.relSubjectGroup[index][0].SPECIALGROUPID;
                                hasGroupArray.push(item);
                                i++;
                                index++;
                            }
                            if (i < result.length) {
                                queryRelSubjectGroup(result[i], callback);
                            } else {
                                callback();
                            }
                        });
                    }
                }
            );
        };

        /**
         * [darftRemove description]  数组去重
         * @param  {[type]} selectArray [description]  当前数组
         * @param  {[type]} dataArray   [description]   再次请求出数组
         * @return {[type]}             [description]
         */
        function darftRemove(selectArray, dataArray, type, callback) {
            var arr = selectArray.concat(dataArray);
            var lastArr = [];
            var num = 0;
            for (var i = 0; i < arr.length; i++) {
                if (!unique(arr[i][type], lastArr, type)) {
                    lastArr.push(arr[i]);
                } else {
                    if (angular.isFunction(callback)) {
                        callback(i - num);
                        num++;
                    }
                }
            }
            return lastArr;
        }

        function unique(n, arr, type) {
            for (var i = 0; i < arr.length; i++) {
                if (n == arr[i][type]) {
                    return true;
                }
            }
            return false;
        }

        // 选择相关新闻或专题
        $scope.selectManuscript = function(item, type) {
            if (type == 'relNewsSelectedItems') {
                if ($scope.data.selectNewArray.indexOf(item) < 0) {
                    $scope.data.selectNewArray.push(item);
                } else {
                    $scope.data.selectNewArray.splice($scope.data.selectNewArray.indexOf(item), 1);
                }
            } else {
                if ($scope.data.selectSubjectArray.indexOf(item) < 0) {
                    $scope.data.selectSubjectArray.push(item);
                } else {
                    $scope.data.selectSubjectArray.splice($scope.data.selectSubjectArray.indexOf(item), 1);
                }
            }
        };

        /**
         * [selectAll description]稿件全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function(type) {
            if (type == 'selectSubjectArray') {
                $scope.data.selectSubjectArray =
                    $scope.data.selectSubjectArray.length == $scope.data.relSubjectSelectedItems.length
                        ? []
                        : [].concat($scope.data.relSubjectSelectedItems);
            } else {
                $scope.data.selectNewArray =
                    $scope.data.selectNewArray.length == $scope.data.relNewsSelectedItems.length ? [] : [].concat($scope.data.relNewsSelectedItems);
            }
        };

        /**
         * [manuscriptDelete description]删除已选稿件
         * @return {[type]} [description]
         */
        $scope.manuscriptDelete = function(type) {
            var index;
            if (type == 'relSubjectSelectedItems') {
                for (var i = 0; i < $scope.data.selectSubjectArray.length; i++) {
                    index = $scope.data.relSubjectSelectedItems.indexOf($scope.data.selectSubjectArray[i]);
                    $scope.data.relSubjectSelectedItems.splice(index, 1);
                }
                $scope.data.selectSubjectArray.length = 0;
            } else {
                for (var i = 0; i < $scope.data.selectNewArray.length; i++) {
                    index = $scope.data.relNewsSelectedItems.indexOf($scope.data.selectNewArray[i]);
                    $scope.data.relNewsSelectedItems.splice(index, 1);
                }
                $scope.data.selectNewArray.length = 0;
            }
        };

        /**
         * [selectRelSubjectGroup description] 选择相关专题稿件的分组
         * @param  {[type]} selectedGroup [description]
         * @return {[type]}               [description]
         */
        $scope.selectRelSubjectGroup = function(item, selectedGroup) {
            item.SPECIALGROUPID = selectedGroup.value;
        };

        /**
         * [cleanRelatedNews description] 清空相关联稿件
         * @param  {[type]} type [description]
         * @return {[type]}      [description]
         */
        $scope.cleanRelatedNews = function(type) {
            $scope.data[type] = [];
            if (type == 'relSubjectSelectedItems') {
                $scope.data.relSubjectGroup = [];
                $scope.data.relSubjectSelectedGroup = [];
            }
        };

        /**
         * [relNewsDelete description] 删除相关新闻或专题
         * @param  {[type]} curIndex [description]
         * @param  {[type]} type     [description]
         * @return {[type]}          [description]
         */
        $scope.relNewsDelete = function(curIndex, type) {
            var index = $scope.data[type].indexOf(curIndex);
            $scope.data[type].splice(index, 1);
            if (type == 'relSubjectSelectedItems') {
                $scope.data.relSubjectGroup.splice(index, 1);
                $scope.data.relSubjectSelectedGroup.splice(index, 1);
            }
        };

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function() {
            $scope.page.CURRPAGE++;
            getVersion();
        };

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function(item) {
            var path = $scope.data.path[item.MEDIATYPE];
            var params = {
                objectversionid: item.OBJECTVERSIONID,
                chnldocid: $state.params.appchnldocid,
            };
            var url = $state.href(path, params);
            item.url = url;
        };

        /**
         * [previewSave description]预览前保存，用于编辑器预览
         * @return {[type]} [description]
         */
        $scope.previewSave = function() {
            var deffer = $q.defer();
            $scope.save(false).then(function(data) {
                $scope.status.openBtn = true;
                $state.params.appchnldocid = $scope.list.CHNLDOCID = data.CHNLDOCID;
                $state.params.appmetadataid = $scope.list.METADATAID = data.METADATAID;
                storageListenerService.addListenerToApp('save');
                $state.transitionTo($state.current, $state.params, {
                    reload: false,
                });
                editIsLock.lockDraft($state.params.appmetadataid);
                deffer.resolve(data);
            });
            // });
            return deffer.promise;
        };

        /**
         * [appPreview description]稿件预览
         * @return {[type]} [description]
         */
        $scope.appPreview = function() {
            $scope.save(false).then(function(data) {
                editIsLock.lockDraft($state.params.appmetadataid);
                mobilePreview();
            });
        };

        /**
         * [mobilePreview description]手机端预览方法
         * @return {[type]} [description]
         */
        function mobilePreview() {
            $scope.loadingPromise = editingCenterAppService.appPrevewPublish($state.params.appchnldocid).then(
                function() {},
                function() {
                    editIsLock.lockDraft($state.params.appmetadataid);
                }
            );
        }

        /**
         * [save description] 保存稿件
         * @param  {[type]} type [description] 是否直接保存
         * @return {[type]}      [description]
         */
        $scope.save = function(type) {
            // 包含本地版本功能的稿件类型做了特殊处理，在进行其他操作时均先做此保存操作，以此来更新本地版本
            type = angular.isDefined(type) ? type : true;
            var deffer = $q.defer();
            save(type).then(
                function() {
                    if (type === true) {
                        editIsLock.lockDraft($state.params.appmetadataid);
                    }
                    getVersion($scope.list.METADATAID).then(function() {
                        var params;
                        if ($scope.status.isFusionEditor) {
                            params = {
                                serviceid: 'mlf_fusioncreate',
                                methodname: 'getAPPFusionDoc',
                                sourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                            };
                        } else {
                            params = {
                                serviceid: 'mlf_appmetadata',
                                methodname: 'getTopicDoc',
                                ChnlDocId: $state.params.appchnldocid,
                            };
                        }
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                            var ue = UE.getEditor('ueditor');
                            ue.ready(function() {
                                ue.setContent(data.HTMLCONTENT);
                                if (!$scope.status.isFusionEditor) {

                                    /* editcenterRightsService.getRightsofBigFace($state.params.appsiteid, 'appsite.trace').then(function(data) {
                                    $scope.status.bigFaceRights = !!data["appsite.trace.chakan"] ? "true" : "false";
                                });*/
                                }
                                ueditorService.saveToLocal($scope.list.METADATAID, 'app', data.HTMLCONTENT, $scope.data.lastVersionid);
                                deffer.resolve(data);
                            });
                        });
                    });
                },
                function() {
                    deffer.reject();
                }
            );
            return deffer.promise;
        };

        /**
         * [save description]保存方法
         * @param  {[boolean]} flag [description]标示位
         * @return {[type]}      [description]
         */
        function save(flag) {
            var deferred = $q.defer();
            $scope.status.isedit = !!$state.params.appmetadataid;
            saveContent();
            $scope.topicForm.$pending = {};
            $validation
                .validate($scope.topicForm)
                .success(function() {
                    modalDialog.isSecretInformation(
                        $state.params.appmetadataid,
                        function() {
                            sensitiveWordCheckService.sensitiveWords($scope).then(
                                function(sensitiveWords) {
                                    // 来自融合编辑器，并且是新建的话，需要先保存我的的虚拟稿
                                    if ($scope.status.isFusionEditor && angular.isUndefined($state.params.iwometadataid)) {
                                        saveFictitiousIwo().then(
                                            function() {
                                                $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                                $scope.list.SENSITIVEWORDS = sensitiveWords;
                                                $scope.topicForm.$setPristine();
                                                var list = dealAttributeBeforeSave();
                                                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                                    function(data) {
                                                        $scope.data.METADATAID = data.METADATAID;
                                                        if (!$scope.status.isedit) {
                                                            $scope.status.isedit = false;
                                                        } else {
                                                            $scope.status.isedit = true;
                                                        }
                                                        dealAttributeAfterSave(data, flag);
                                                        beforeonload.refresh($scope);
                                                        deferred.resolve(data);
                                                    },
                                                    function(data) {
                                                        $scope.status.openBtn = true;
                                                        deferred.reject(data);
                                                    }
                                                );
                                            },
                                            function() {
                                                deferred.reject();
                                            }
                                        );
                                    } else {
                                        $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                        $scope.list.SENSITIVEWORDS = sensitiveWords;
                                        $scope.topicForm.$setPristine();
                                        var list = dealAttributeBeforeSave();
                                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                            function(data) {
                                                $scope.data.METADATAID = data.METADATAID;
                                                if (!$scope.status.isedit) {
                                                    $scope.status.isedit = false;
                                                } else {
                                                    $scope.status.isedit = true;
                                                }
                                                dealAttributeAfterSave(data, flag);
                                                beforeonload.refresh($scope);
                                                deferred.resolve(data);
                                            },
                                            function(data) {
                                                $scope.status.openBtn = true;
                                                deferred.reject(data);
                                            }
                                        );
                                    }
                                },
                                function() {
                                    $scope.status.isCheckSensitiveWords = Math.random();
                                    deferred.reject();
                                }
                            );
                        },
                        function() {
                            deferred.reject();
                        },
                        $scope.status.isFusionEditor
                    );
                })
                .error(function() {
                    editingCenterService.checkSaveError($scope.topicForm, $element, $scope); // 定位输入错的表单位置
                    deferred.reject();
                });
            return deferred.promise;
        }

        /**
         * [saveContent description]保存正文
         * @return {[type]} [description]
         */
        function saveContent() {
            ueditorService.saveContent($scope.list);
            if ($scope.list.HTMLCONTENT === '') {
                $timeout(function() {
                    // 表单校验手动触发
                    $scope.topicForm.content.$error.content = true;
                    $scope.topicForm.content.$valid = false;
                    $scope.topicForm.content.$invalid = true;
                    $scope.topicForm.$error.content = [$scope.topicForm.content];
                    $scope.topicForm.$valid = false;
                    $scope.topicForm.$invalid = true;
                });
            }
        }

        /**
         * [dealAttributeBeforeSave description]保存前处理保存属性
         * @return {[obj]} [description]list对象
         */
        function dealAttributeBeforeSave() {
            $scope.status.openBtn = false;
            getKeyWords();
            $scope.list.TOPICSTARTTIME = $filter('date')(Date.parse($scope.list.TOPICSTARTTIME), 'yyyy-MM-dd').toString();
            $scope.list.TOPICENDTIME = $filter('date')(Date.parse($scope.list.TOPICENDTIME), 'yyyy-MM-dd').toString();

            /* $scope.list.BELONGCHANNEL = {
                TYPE: $scope.data.selectedChannel.NAME || 　"",
                NAME: $scope.data.selectedChildrenChannel.NAME || "",
                VALUE: $scope.data.selectedChildrenChannel.ID || ""
            };*/
            // $scope.list.FIGURE = $scope.list.ISSELECTFIGURE == '0' ? [] : $scope.list.FIGURE;
            getRelavantSpecialDoc();
            var list = angular.copy($scope.list);
            // 处理发稿单作者信息空数据提交问题
            if (
                angular.isDefined(list.FGD_AUTHINFO[0]) &&
                (!angular.isDefined(list.FGD_AUTHINFO[0].USERNAME) || list.FGD_AUTHINFO[0].USERNAME === '')
            ) {
                list.FGD_AUTHINFO = [];
            }
            list.CONTRIBUTORSAUTHER = $scope.data.userName;
            // 处理发稿单作者信息空数据提交问题
            if ($scope.status.isFusionEditor) {
                delete list.ISNOPAYMENT;
                delete list.FGD_EDITINFO;
                delete list.FGD_AUTHINFO;
                delete list.DOCGENRE;
                list.ORIGINALTYPE = $scope.data.originType;
                list.SPECIALDOC = $scope.data.specialDoc;
                list.METADATAID = $state.params.appmetadataid || '0';
                list.serviceid = 'mlf_fusionapp';
                list.methodname = 'saveFictitionsTopicDoc';
                list.SourceDocId = $scope.data.sourceDocId || $state.params.iwometadataid;
            } else {
                list.serviceid = 'mlf_appmetadata';
                list.methodname = 'saveTopicDoc';
            }
            list = jsonArrayToStringService.jsonArrayToString(list);
            list.ORIGINALTYPE = $scope.data.originType;
            list.SPECIALDOC = $scope.data.specialDoc;
            return list;
        }

        /**
         * [getRelavantSpecialDoc description] 获取相关专题
         * @return {[type]} [description]
         */
        function getRelavantSpecialDoc() {
            darftRemove($scope.data.relSubjectSelectedItems, [], 'SPECIALGROUPID', function(index) {
                $scope.data.relSubjectSelectedItems.splice(index, 1);
                $scope.data.relSubjectGroup.splice(index, 1);
                $scope.data.relSubjectSelectedGroup.splice(index, 1);
            });
            $scope.list.RELEVANTSPECIALDOC = [];
            angular.forEach($scope.data.relSubjectSelectedItems, function(data, index) {
                $scope.list.RELEVANTSPECIALDOC.push({
                    METADATAID: data.METADATAID,
                    SPECIALGROUPID: data.SPECIALGROUPID,
                });
            });
            $scope.list.RELEVANTSPECIALDOC = jsonArrayToStringService.clearEmptyArray($scope.list.RELEVANTSPECIALDOC);
        }

        /**
         * [getKeyWords description]获取关键词
         * @return {[type]} [description]
         */
        function getKeyWords() {
            $scope.list.KEYWORDS = '';
            angular.forEach($scope.data.KEYWORDS, function(data, index, array) {
                if (index != $scope.data.KEYWORDS.length - 1) {
                    $scope.list.KEYWORDS += data.name + ';';
                } else {
                    $scope.list.KEYWORDS += data.name;
                }
            });
        }

        /**
         * [dealAttributeAfterSave description]保存成功后处理属性
         * @param  {[obj]} data [description]保存后后台返回值
         * @param  {[boolean]} flag [description]标识位
         * @return {[type]}      [description]
         */
        function dealAttributeAfterSave(data, flag) {
            $scope.status.openBtn = true;
            $state.params.appchnldocid = $scope.list.CHNLDOCID = data.CHNLDOCID;
            $state.params.appmetadataid = $scope.list.METADATAID = data.METADATAID;
            if (flag) {
                if (!$scope.status.isFusionEditor) {
                    storageListenerService.addListenerToApp('save');
                    $state.transitionTo($state.current, $state.params, {
                        reload: false,
                    });
                }
                if (!$scope.status.isFusionEditor) {
                    $timeout(function() {
                        modalDialog.saveModel('保存成功', '', 'success');
                    }, 500);
                }
            } else {
                $scope.params.MetaDataIds = $scope.list.METADATAID;
                $scope.params.CHNLDOCIDS = $scope.list.CHNLDOCID;
                $scope.params.ObjectIds = $scope.list.CHNLDOCID;
                $scope.params.serviceid = 'mlf_appoper';
            }
        }

        /**
         * [appTrial description]APP送审操作
         * @return {[type]} [description]
         */
        $scope.appTrial = function() {
            $scope.save(false).then(function() {
                trial();
            });
        };

        /**
         * [trial description]稿件送审
         * @return {[type]} [description]
         */
        function trial() {
            modalDialog.inputModel(
                '送审',
                '请输入送审意见',
                function(content) {
                    var params = {
                        serviceid: 'mlf_appoper',
                        methodname: 'trialMetaDatas',
                        MetaDataIds: $scope.list.METADATAID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        ChannelId: $state.params.appchannelid,
                        Opinion: content,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', false).then(
                        function(data) {
                            modalDialog.alertType(
                                '送审成功',
                                '',
                                'success',
                                false,
                                function() {
                                    storageListenerService.addListenerToApp('send');
                                    $window.close();
                                },
                                '',
                                1500
                            );
                        },
                        function() {
                            editIsLock.lockDraft($state.params.appmetadataid);
                        }
                    );
                },
                '',
                function() {
                    editIsLock.lockDraft($state.params.appmetadataid);
                }
            );
        }

        /**
         * [appSignDirect description]app直接签发
         * @return {[type]} [description]
         */
        $scope.appSignDirect = function() {
            signDirect();
        };

        /**
         * [signDirect description] 直接签发
         * @param   {[type]}  isSaveAndPublish  [isSaveAndPublish description]
         * @return  {[type]}                    [return description]
         */
        function signDirect(isSaveAndPublish) {
            var array = [$scope.list];
            if (isSaveAndPublish) {
                signPrivate();
            } else {
                sensitiveWordCheckService.SensitiveWordsAndCareful(array, true, '1').then(
                    function() {
                        signPrivate();
                    },
                    function() {
                        signPrivate();
                    }
                );
            }

        }

        /**
         * [signPrivate description]
         * @return  {[type]}  [return description]
         */
        function signPrivate() {
            var methodname = ['appDaiBianPublish', 'appDaiShenPublish', 'appYiQianFaPublish'];
            $scope.loadingPromise = newMediaService.sign($scope).then(function() {
                $scope.save(false).then(() => {
                    let signParams = {
                        serviceid: 'mlf_appoper',
                        methodname: methodname[$state.params.appplatform],
                        ObjectIds: $scope.list.CHNLDOCID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                    };
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        }

        /**
         * [appSignTiming description]定时签发
         * @return {[type]} [description]
         */
        $scope.appSignTiming = function() {
            if ($scope.status.isSecondReview === true) {
                modalDialog.alertType('无法进行操作', '该稿件处于二次送审流程中，不能定时签发', 'warning', 'confirm');
                return;
            }
            timeSign();
        };

        /**
         * [timeSign description]定时签发函数
         * @return {[type]} [description]
         */
        function timeSign() {
            var methodname = ['appDaiBianTimingPublish', 'appDaiShenTimingPublish'];
            $scope.loadingPromise = newMediaService.timeSign($scope).then(function() {
                $scope.save(false).then(() => {
                    let signParams = {
                        serviceid: 'mlf_appoper',
                        methodname: methodname[$state.params.appplatform],
                        ObjectIds: $scope.list.CHNLDOCID,
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                    };
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        }

        /**
         * [appRevoke description]稿件撤稿
         * @return {[type]} [description]
         */
        $scope.appRevoke = function() {
            $scope.save(false).then(function(data) {
                revoke();
            });
        };

        /**
         * [revoke description]撤稿函数
         * @return {[type]} [description]
         */
        function revoke() {
            modalDialog.inputModel(
                '撤稿',
                '撤稿原因（选填）',
                function(content) {
                    var params = {
                        serviceid: 'mlf_appoper',
                        methodname: 'rejectionMetaDatas',
                        ChnlDocIds: $scope.list.CHNLDOCID,
                        MetaDataIds: $scope.list.METADATAID,
                        Opinion: content,
                        ChannelId: $state.params.appchannelid,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', false).then(
                        function() {
                            modalDialog.alertType(
                                '撤稿成功',
                                '',
                                'success',
                                false,
                                function() {
                                    $scope.status.isSignedOrRevoked = true;
                                    storageListenerService.addListenerToApp('revoke');
                                    $window.close();
                                },
                                '',
                                1500
                            );
                        },
                        function() {
                            editIsLock.lockDraft($state.params.appmetadataid);
                        }
                    );
                },
                '',
                function() {
                    editIsLock.lockDraft($state.params.appmetadataid);
                }
            );
        }

        /**
         * [appSavePublish description]保存并发布
         * @return {[type]} [description]
         */
        $scope.appSavePublish = function() {
            // $scope.save(false).then(function(data) {
            signDirect(true);
            // });
        };

        /**
         * [appSecondReview description] 已签发平台二次送审
         * @return {[type]} [description]
         */
        $scope.appSecondReview = function() {
            if ($scope.status.isSecondReview === true) {
                modalDialog.alertType('无法进行操作', '该稿件处于二次送审流程中，不能重复送审', 'warning', 'confirm');
                return;
            }
            modalDialog.confirmModal('二次送审', '确认送审稿件', function() {
                appSecondReview();
            });
        };

        /**
         * [appSecondReview description] 二次送审函数(不做保存，但把保存方法里的稿件信息全部作为参数传过去)
         * @param  {[type]} metadataid [description]
         * @return {[type]}            [description]
         */
        function appSecondReview() {
            var ue = UE.getEditor('ueditor');
            saveContent();
            $scope.topicForm.$pending = {};
            $validation
                .validate($scope.topicForm)
                .success(function() {
                    sensitiveWordCheckService.sensitiveWords($scope).then(
                        function(sensitiveWords) {
                            $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                            $scope.list.SENSITIVEWORDS = sensitiveWords;
                            $scope.topicForm.$setPristine();
                            var list = dealAttributeBeforeSave();
                            list.serviceid = 'mlf_appoper';
                            list.methodname = 'makeNewDuplication';
                            list.MetaDataId = list.METADATAID;
                            list.ChannelId = list.CHANNELID;
                            delete list.METADATAID;
                            delete list.CHANNELID;
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                function(data) {
                                    if (data.ISSUCCESS == 'true') {
                                        getVersion($scope.list.METADATAID).then(function() {
                                            var params = {
                                                serviceid: 'mlf_appmetadata',
                                                methodname: 'getTopicDoc',
                                                ChnlDocId: $state.params.appchnldocid,
                                            };
                                            $scope.loadingPromise = trsHttpService
                                                .httpServer(trsHttpService.getWCMRootUrl(), params, 'get')
                                                .then(function(data) {
                                                    var ue = UE.getEditor('ueditor');
                                                    ue.ready(function() {
                                                        ue.setContent(data.HTMLCONTENT);

                                                        /* editcenterRightsService.getRightsofBigFace($state.params.appsiteid, 'appsite.trace').then(function(data) {
                                                $scope.status.bigFaceRights = !!data["appsite.trace.chakan"] ? "true" : "false";
                                            });*/
                                                        ueditorService.saveToLocal(
                                                            $scope.list.METADATAID,
                                                            'app',
                                                            data.HTMLCONTENT,
                                                            $scope.data.lastVersionid
                                                        );
                                                        modalDialog.alertType(
                                                            '二次送审成功',
                                                            '',
                                                            'success',
                                                            false,
                                                            function() {
                                                                $scope.status.isSecondReview = true;
                                                                storageListenerService.addListenerToApp('secondReview');
                                                                $window.close();
                                                            },
                                                            '',
                                                            1500
                                                        );
                                                    });
                                                });
                                        });
                                    } else {
                                        modalDialog.alertType('二次送审失败', '', 'error', 'confirm');
                                    }
                                },
                                function(data) {
                                    $scope.status.openBtn = true;
                                    modalDialog.alertType('二次送审失败', '', 'error', 'confirm');
                                }
                            );
                        },
                        function() {
                            $scope.status.isCheckSensitiveWords = Math.random();
                        }
                    );
                })
                .error(function() {
                    editingCenterService.checkSaveError($scope.topicForm); // 定位输入错的表单位置
                });

            /* var params = {
                "serviceid": "mlf_appoper",
                "methodname": "makeNewDuplication",
                "MetaDataId": metadataid
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                if (data.ISSUCCESS == 'true') {
                    modalDialog.alertType("二次送审成功", "", "success", false, function() {
                        $scope.status.isSecondReview = true;
                        storageListenerService.addListenerToApp("secondReview");
                        $window.close();
                    }, "", 1500);

                } else {
                    modalDialog.alertType("二次送审失败", "", "error", false);
                    editIsLock.lockDraft($state.params.appmetadataid);
                }
            }, function(data) {
                modalDialog.alertType("二次送审失败", "", "error", false);
                editIsLock.lockDraft($state.params.appmetadataid);
            });*/
        }

        /**
         * [revise description] 修订
         * @return {[type]} [description]
         */
        $scope.revise = function() {
            save().then(
                function() {
                    var params = {
                        serviceid: 'mlf_modifydoc',
                        methodname: 'paperModifyDocsFinished',
                        PaperDocIds: $state.params.appmetadataid,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                        function(data) {
                            modalDialog.alertType(
                                '修订成功',
                                '',
                                'success',
                                false,
                                function() {
                                    storageListenerService.addListenerToNewspaper('xiuding');
                                    $window.close();
                                },
                                '',
                                1500
                            );
                        },
                        function(data) {
                            editIsLock.lockDraft($state.params.appmetadataid);
                        }
                    );
                },
                function() {
                    editIsLock.lockDraft($state.params.appmetadataid);
                }
            );
        };

        /**
         * [close description]关闭页面
         * @return {[type]} [description]
         */
        $scope.close = function() {
            editingCenterService
                .closeWinow($scope.topicForm.$dirty, ueditorService.contentTranscoding($scope.list) != ueditorService.bindContent())
                .then(
                    function() {
                        $scope.save(false).then(function() {
                            storageListenerService.addListenerToApp('save');
                            editIsLock.normalLock($state.params.appmetadataid).then(function(data) {
                                $window.open('about:blank', '_self').close();
                            });
                        });
                    },
                    function() {
                        angular.isDefined($state.params.appmetadataid)
                            ? editIsLock.normalLock($state.params.appmetadataid).then(function(data) {
                                $window.open('about:blank', '_self').close();
                            })
                            : $window.open('about:blank', '_self').close();
                    }
                );
        };

        /* 融合编辑器额外功能开始*/
        /**
         * [saveFictitiousIwo description] 保存虚拟我的稿件
         * @return {[type]} [description]
         */
        function saveFictitiousIwo() {
            var defer = $q.defer();
            var doctype = editFusionEditorService.getDoctypeByRouter($state.current.name);
            var params = editFusionEditorService.getIwoListByDoctype(doctype, $state.params.iwoplatform);
            var ue = UE.getEditor('ueditor');
            params.HTMLCONTENT = ue.getContent();
            params.DOCWORDSCOUNT = $scope.list.DOCWORDSCOUNT;
            params.TITLE = $scope.list.TITLE;
            params.ISNOPAYMENT = $scope.list.ISNOPAYMENT;
            params.FGD_EDITINFO = $scope.list.FGD_EDITINFO;
            params.FGD_AUTHINFO = $scope.list.FGD_AUTHINFO;
            params.DOCGENRE = $scope.list.DOCGENRE;
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                function(data) {
                    $scope.data.sourceDocId = data.METADATAID;
                    $scope.data.iwometadataid = data.METADATAID;
                    $scope.data.iwochnldocid = data.CHNLDOCID;
                    defer.resolve();
                },
                function() {
                    defer.reject();
                }
            );
            return defer.promise;
        }

        /* 融合编辑器额外功能结束*/
        /**
         * [initOrigin description]初始化原创
         * @return {[type]} [description]
         */
        function initOrigin() {
            if (!$state.params.appmetadataid) {return;}
            // $scope.status.nopayment = true;
            for (var i = 0; i < $scope.data.originList.length; i++) {
                if ($scope.list.ORIGINALTYPE == $scope.data.originList[i].value) {
                    $scope.checkOrigin($scope.data.originList[i]);
                    break;
                }
            }
            $scope.data.specialDoc = $scope.list.SPECIALDOC;
        }
        // 原创声明
        $scope.oringin = function(list) {
            if (list.ORIGINAL === '1') {
                $scope.list.ORIGINAL = '0';
                $scope.data.originType = '0';
            } else {
                $('.newsResourcesTips')
                    .find('.tips')
                    .remove();
                $scope.list.ORIGINAL = '1';
                $scope.data.originType = $scope.data.originList[0].value;
                $scope.data.specialDoc = 0;
            }
            // if (!$scope.status.nopayment) {
            //     $scope.status.nopayment = true;
            //     $scope.list.ISNOPAYMENT = '0';
            // }
        };
        // 点击特殊稿
        $scope.specialDoc = function() {
            if ($scope.data.specialDoc == 1) {
                $scope.data.specialDoc = 0;
            } else {
                $('.newsResourcesTips')
                    .find('.tips')
                    .remove();
                $scope.data.specialDoc = 1;
                $scope.list.ORIGINAL = '0';
                $scope.data.originType = '0';
            }
        };
        // 勾选原创稿二级单选的原创类型
        $scope.checkOrigin = function(item) {
            $('.newsResourcesTips')
                .find('.tips')
                .remove();
            $scope.data.originType = item.value;
            $scope.list.ORIGINAL = '1';
            $scope.data.specialDoc = 0;
            // if (!$scope.status.nopayment) {
            //     $scope.status.nopayment = true;
            //     $scope.list.ISNOPAYMENT = '0';
            // }
        };

        /**
         * [syncTitleToListTitle 将文章标题同步给列表标题]
         *
         * @return  {[type]}  [return description]
         */
        $scope.syncTitleToListTitle = function(){
            syncTitleToListTitle();
        };

        /**
         * [syncTitleToListTitle 将文章标题同步给列表标题实现]
         *
         * @return  {[type]}  [return description]
         */
        function syncTitleToListTitle(){
            if ($scope.status.hasTitleSynced){
                return;
            } else {
                if ($scope.list.LISTTITLE !== '') {
                    return;
                } else {
                    $scope.list.LISTTITLE = $scope.list.TITLE;
                    $scope.status.hasTitleSynced = true;
                }
            }
        }

        /**
         * [changeMode description] 列表图模式切换，html调用
         *
         * @param   {[type]}  listStyle  [listStype description]
         *
         * @return  {[type]}             [return description]
         */
        $scope.changeMode = function(listStyle) {
            $scope.list.LISTSTYLE = listStyle.value;
            changeMode(listStyle.value);
        };

        /**
         * [changeMode description] js内部调用
         *
         * @param   {[type]}  value  [listStype description]
         *
         * @return  {[type]}  [return description]
         */
        function changeMode(value) {
            if ($scope.status.pictureSize) {
                switch (value) {
                    case '0':
                        $scope.data.imgSize = $scope.status.pictureSize.TOPICSIZE;
                        break;
                    case '3':
                        $scope.data.imgSize = $scope.status.pictureSize.TOPBIGSIZE;
                        break;
                }
            }
        }

        /**
         * [关闭窗口]
         */
        $scope.closeWindow = function(){
            editingCenterService.closeWindow('app', $scope);
        };

        /**
         * [保存内容并关闭窗口]
         */
        $scope.saveAndClose = function() {
            $scope.save(false).then(function(){
                window.close();
            });
        };
    },
]);
